import Dropzone from 'dropzone';

Dropzone.autoDiscover = false;

window.App = window.App || {};

App.ArtAssetBatches = (function() {
  function init() {
    // only run on ArtAssetBatches pages
    if (!$('body').hasClass('art_asset_batches-c')) return;
    initSelect2();
    initCopyButtons();
    if ($('body').hasClass('show-a')) {
      initDropzone();
      initTableActions();
      initImageDropzone();
      initImageGalleryActions();
    }
    if ($('body').hasClass('email_preview-a')) {
      initEmailPreview();
    }
  }

  function initSelect2() {
    if ($.fn.select2) {
      $('.js-select2').select2({ width: '100%' });
      $('.js-license-select2').select2({ width: '160px', placeholder: '- Not Set -', allowClear: true });
    }
  }

  function initDropzone() {
    var el = document.getElementById('art-asset-dropzone');
    if (!el) return;

    var uploadUrl = el.getAttribute('data-upload-url');
    if (!uploadUrl) return;

    var dz = new Dropzone(el, {
      url: uploadUrl,
      paramName: 'file',
      maxFilesize: 2048, // MB; server/proxy may be lower
      acceptedFiles: '.zip',
      addRemoveLinks: false,
      timeout: 0,
      sending: function(file, xhr) { $.rails.CSRFProtection(xhr); },
    });

    dz.on('success', function(file, resp) {
      if (!resp || !resp.success) {
        App.Alert.show((resp && resp.error) ? resp.error : 'Upload failed', 'alert');
        return;
      }
      addAssetRow(resp.asset, resp.public_download_url);
      App.Alert.show('Uploaded: ' + resp.asset.original_filename, 'notice');
    });

    dz.on('error', function(file, msg) {
      var text = (typeof msg === 'string') ? msg : (msg && msg.error) ? msg.error : 'Upload failed';
      App.Alert.show(text, 'alert');
    });
  }

  function initImageDropzone() {
    var el = document.getElementById('art-asset-image-dropzone');
    if (!el) return;

    var uploadUrl = el.getAttribute('data-upload-url');
    if (!uploadUrl) return;

    var dz = new Dropzone(el, {
      url: uploadUrl,
      paramName: 'file',
      maxFilesize: 50, // MB
      acceptedFiles: '.png,.jpg,.jpeg,image/png,image/jpeg',
      addRemoveLinks: false,
      timeout: 0,
      sending: function(file, xhr) { $.rails.CSRFProtection(xhr); },
    });

    dz.on('success', function(file, resp) {
      if (!resp || !resp.success) {
        App.Alert.show((resp && resp.error) ? resp.error : 'Upload failed', 'alert');
        return;
      }
      addBatchImageCard(resp.image);
      App.Alert.show('Uploaded: ' + resp.image.original_filename, 'notice');
    });

    dz.on('error', function(file, msg) {
      var text = (typeof msg === 'string') ? msg : (msg && msg.error) ? msg.error : 'Upload failed';
      App.Alert.show(text, 'alert');
    });
  }

  function initImageGalleryActions() {
    var gallery = document.getElementById('art-asset-image-gallery');
    if (!gallery) return;
    installCsrfAjaxHeader();

    $(gallery).on('click', '.js-delete-batch-image', function(e) {
      e.preventDefault();
      if (!confirm('Delete this image? This also deletes the S3 object.')) return;
      var card = $(this).closest('.art-asset-image-card');
      var imageId = card.data('image-id');
      var tmpl = gallery.getAttribute('data-destroy-url-template');
      if (!tmpl) return;
      var url = tmpl.replace('IMAGE_ID', imageId);

      $.ajax({
        url: url,
        type: 'DELETE',
      }).done(function(resp) {
        if (resp && resp.success) {
          card.remove();
          App.Alert.show('Deleted', 'notice');
          ensureEmptyImageRow();
        } else {
          App.Alert.show('Delete failed', 'alert');
        }
      }).fail(function(xhr) {
        App.Alert.show('Delete failed - status: ' + xhr.status, 'alert');
      });
    });
  }

  function ensureEmptyImageRow() {
    var gallery = $('#art-asset-image-gallery');
    if (!gallery.length) return;
    var hasCards = gallery.find('.art-asset-image-card').length > 0;
    if (!hasCards && gallery.find('.js-empty-image-row').length === 0) {
      gallery.append('<div class="js-empty-image-row" style="color: #888; font-style: italic;">No images uploaded yet.</div>');
    }
  }

  function addBatchImageCard(image) {
    var gallery = $('#art-asset-image-gallery');
    if (!gallery.length) return;
    gallery.find('.js-empty-image-row').remove();

    var card = $('<div>')
      .addClass('art-asset-image-card')
      .attr('data-image-id', image.id)
      .data('image-id', image.id)
      .css({ width: '180px', border: '1px solid #ddd', borderRadius: '4px', padding: '8px', background: '#fff' });

    var thumbHtml = '<a href="' + esc(image.public_url) + '" target="_blank">' +
      '<img src="' + esc(image.thumb_url) + '" style="max-width: 100%; height: auto; display: block;">' +
    '</a>';

    var fnameHtml = '<div style="font-size: 11px; word-break: break-all; margin-top: 4px;">' +
      esc(image.original_filename || '') +
    '</div>';

    var copyHtml = '<div style="margin-top: 6px; display: flex; gap: 4px;">' +
      '<input type="text" id="art-asset-image-url-' + image.id + '" class="art-asset-copy-input" value="' + esc(image.public_url) + '" readonly style="flex: 1; min-width: 0;">' +
      '<button class="button tiny secondary js-copy" data-copy-target="#art-asset-image-url-' + image.id + '">Copy</button>' +
    '</div>';

    var deleteHtml = '<button class="button tiny alert js-delete-batch-image" style="margin-top: 6px; width: 100%;">Delete</button>';

    card.html(thumbHtml + fnameHtml + copyHtml + deleteHtml);
    gallery.prepend(card);
  }

  function tableEl() {
    return document.getElementById('art-assets-table');
  }

  function updateUrlFor(assetId) {
    var table = tableEl();
    var tmpl = table.getAttribute('data-update-url-template');
    return tmpl.replace('ASSET_ID', assetId);
  }

  function initTableActions() {
    var table = tableEl();
    if (!table) return;
    installCsrfAjaxHeader();

    $(table).on('click', '.js-save-asset', function(e) {
      e.preventDefault();
      var tr = $(this).closest('tr');
      var assetId = tr.data('asset-id');
      var url = updateUrlFor(assetId);

      var payload = { art_asset: {} };
      tr.find('.js-asset-field').each(function() {
        payload.art_asset[$(this).data('field')] = $(this).val();
      });

      $.ajax({
        url: url,
        type: 'PATCH',
        data: payload,
      }).done(function(resp) {
        if (resp && resp.success) {
          App.Alert.show('Saved', 'notice');
        } else {
          App.Alert.show('Save failed', 'alert');
        }
      }).fail(function(xhr) {
        if (xhr.status === 422) {
          var data = $.parseJSON(xhr.responseText);
          App.Alert.show((data.errors || []).join(', ') || 'Validation failed', 'alert');
        } else {
          App.Alert.show('Save failed - status: ' + xhr.status, 'alert');
        }
      });
    });

    $(table).on('click', '.js-delete-asset', function(e) {
      e.preventDefault();
      if (!confirm('Delete this asset? This also deletes the S3 object.')) return;
      var tr = $(this).closest('tr');
      var assetId = tr.data('asset-id');
      var url = updateUrlFor(assetId);

      $.ajax({
        url: url,
        type: 'DELETE',
      }).done(function(resp) {
        if (resp && resp.success) {
          tr.remove();
          App.Alert.show('Deleted', 'notice');
          ensureEmptyRow();
        } else {
          App.Alert.show('Delete failed', 'alert');
        }
      }).fail(function(xhr) {
        App.Alert.show('Delete failed - status: ' + xhr.status, 'alert');
      });
    });
  }

  function installCsrfAjaxHeader() {
    var token = $('meta[name="csrf-token"]').attr('content');
    if (!token) return;
    $.ajaxSetup({
      headers: { 'X-CSRF-Token': token }
    });
  }

  function ensureEmptyRow() {
    var table = $('#art-assets-table');
    if (!table.length) return;
    var hasRows = table.find('tbody tr[data-asset-id]').length > 0;
    if (!hasRows && table.find('tr.js-empty-row').length === 0) {
      table.find('tbody').append('<tr class="js-empty-row"><td colspan="8" class="text-center">No assets uploaded yet.</td></tr>');
    }
  }

  function publicDownloadUrlFor(assetId, fallbackUrl) {
    if (fallbackUrl) return fallbackUrl;
    var table = tableEl();
    if (!table) return '';
    var tmpl = table.getAttribute('data-public-download-url-template');
    if (!tmpl) return '';
    return tmpl.replace('ASSET_ID', assetId);
  }

  function addAssetRow(asset, fallbackPublicUrl) {
    var table = $('#art-assets-table');
    if (!table.length) return;
    table.find('tr.js-empty-row').remove();

    var row = $('<tr>').attr('data-asset-id', asset.id).data('asset-id', asset.id);
    row.append('<td>' + buildLicenseSelect(asset.license_name || '') + '</td>');
    row.append('<td><input class="js-asset-field" data-field="our_style_number" value="' + esc(asset.our_style_number || '') + '"></td>');
    row.append('<td><input class="js-asset-field" data-field="art_name" value="' + esc(asset.art_name || '') + '"></td>');
    row.append('<td><input class="js-asset-field" data-field="shirt_color" value="' + esc(asset.shirt_color || '') + '"></td>');
    row.append('<td><input class="js-asset-field" data-field="vendor_blank_style_number" value="' + esc(asset.vendor_blank_style_number || '') + '"></td>');
    row.append('<td style="max-width: 260px; overflow: hidden; text-overflow: ellipsis;">' + esc(asset.original_filename || '') + '</td>');
    var publicUrl = publicDownloadUrlFor(asset.id, fallbackPublicUrl);
    row.append(
      '<td style="width: 220px">' +
        '<input type="text" id="art-asset-public-url-' + asset.id + '" class="art-asset-copy-input js-asset-public-url" value="' + esc(publicUrl) + '" readonly> ' +
        '<button class="button tiny secondary js-copy" data-copy-target="#art-asset-public-url-' + asset.id + '">Copy</button>' +
      '</td>'
    );
    row.append('<td style="width: 120px"><button class="button tiny js-save-asset">Save</button> <button class="button tiny alert js-delete-asset">Delete</button></td>');
    table.find('tbody').prepend(row);

    // Initialize Select2 on the new select
    if ($.fn.select2) {
      row.find('.js-license-select2').select2({ width: '160px', placeholder: '- Not Set -', allowClear: true });
    }
  }

  function buildLicenseSelect(selected) {
    var table = tableEl();
    var raw = table ? table.getAttribute('data-license-options') : '';
    var opts = raw ? raw.split('---') : [];
    var html = '<select class="js-asset-field js-license-select2" data-field="license_name" style="width: 160px;">';
    html += '<option></option>';
    for (var i = 0; i < opts.length; i++) {
      var v = (opts[i] || '').toString();
      if (!v) continue;
      var sel = (v === selected) ? ' selected' : '';
      html += '<option value="' + esc(v) + '"' + sel + '>' + esc(v) + '</option>';
    }
    html += '</select>';
    return html;
  }

  function initCopyButtons() {
    $(document).on('click', '.js-copy', function(e) {
      e.preventDefault();
      var sel = $(this).data('copy-target');
      if (!sel) return;
      var input = document.querySelector(sel);
      if (!input) return;
      input.focus();
      input.select();
      try {
        document.execCommand('copy');
        App.Alert.show('Copied', 'notice');
      } catch (e2) {
        App.Alert.show('Copy failed', 'alert');
      }
    });
  }

  function initEmailPreview() {
    var editorEl = document.getElementById('art-asset-email-editor');
    var hiddenInput = document.getElementById('art-asset-email-message-plain');
    var $preview = $('#art-asset-email-preview .js-email-message');
    var plainOutput = document.getElementById('art-asset-email-plain-output');
    var assetsPlainEl = document.getElementById('art-asset-email-assets-plain');
    var recipientsEl = document.getElementById('art-asset-email-recipients');
    var subjectEl = document.getElementById('art-asset-email-subject');
    var assetsHtmlEl = document.getElementById('art-asset-email-assets-html');
    var htmlOutput = document.getElementById('art-asset-email-html-output');
    if (!editorEl || !hiddenInput || !$preview.length || !plainOutput || !assetsPlainEl || !recipientsEl || !subjectEl || !assetsHtmlEl || !htmlOutput) return;

    try {
      if (typeof Quill === 'undefined') {
        App.Alert.show('Editor failed to load (Quill missing).', 'alert');
        return;
      }

      var quill = new Quill(editorEl, {
        theme: 'snow',
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline'],
            [{ list: 'ordered' }, { list: 'bullet' }],
            ['link'],
            ['clean']
          ]
        }
      });

      var initialText = hiddenInput.value || '';
      if (initialText) quill.setText(initialText);

      function currentMessagePlain() {
        // Quill getText ends with a newline; normalize it for emails.
        var t = quill.getText ? quill.getText() : (quill.root ? quill.root.innerText : '');
        t = (t || '').replace(/\n{2,}/g, '\n\n');
        return t.replace(/\n$/, '');
      }

      function sync() {
        var msgPlain = currentMessagePlain();
        // Message-only preview: do not overwrite the asset list below it.
        $preview.html(esc(msgPlain).replace(/\n/g, '<br>'));

        var assetsPlain = (assetsPlainEl.value || '').toString().trim();
        var full = msgPlain;
        if (assetsPlain) {
          full = full + "\n\n" + assetsPlain;
        }
        plainOutput.value = full;

        // Rich HTML output for Gmail paste (buttons).
        var msgHtml = (quill.root && quill.root.innerHTML) ? quill.root.innerHTML.toString() : esc(msgPlain).replace(/\n/g, '<br>');
        var assetsHtml = (assetsHtmlEl.innerHTML || '').toString();
        htmlOutput.value = '<div style="font-family:Arial, sans-serif; font-size:14px; color:#111;">' +
          msgHtml +
          '<div style="height:16px;"></div>' +
          assetsHtml +
        '</div>';
      }

      quill.on('text-change', sync);
      sync();

      function saveRecipients() {
        var btn = document.querySelector('.js-copy-and-email');
        var url = btn ? btn.getAttribute('data-save-url') : null;
        if (!url) return $.Deferred().resolve().promise();
        return $.ajax({
          url: url,
          method: 'PATCH',
          dataType: 'json',
          data: { recipients: recipientsEl.value || '' }
        });
      }

      $(document).on('blur', '#art-asset-email-recipients', function() {
        saveRecipients();
      });

      function copyTextToClipboard(text) {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          return navigator.clipboard.writeText(text);
        }
        var tmp = document.createElement('textarea');
        tmp.value = text;
        tmp.setAttribute('readonly', '');
        tmp.style.position = 'fixed';
        tmp.style.left = '-9999px';
        document.body.appendChild(tmp);
        tmp.focus();
        tmp.select();
        try {
          document.execCommand('copy');
        } finally {
          document.body.removeChild(tmp);
        }
        return $.Deferred().resolve().promise();
      }

      function copyHtmlAndTextToClipboard(html, text) {
        // Prefer rich copy for Gmail paste.
        try {
          if (navigator.clipboard && window.ClipboardItem && navigator.clipboard.write) {
            var htmlBlob = new Blob([html], { type: 'text/html' });
            var textBlob = new Blob([text], { type: 'text/plain' });
            var item = new ClipboardItem({ 'text/html': htmlBlob, 'text/plain': textBlob });
            return navigator.clipboard.write([item]);
          }
        } catch (e) { /* fall through */ }
        return copyTextToClipboard(text);
      }

      $(document).on('click', '.js-copy-and-email', function(e) {
        e.preventDefault();

        var content = (plainOutput.value || '').toString();
        var html = (htmlOutput.value || '').toString();
        var recipient = (recipientsEl.value || '').toString();
        var subject = (subjectEl.value || '').toString();

        saveRecipients().always(function() {
          copyHtmlAndTextToClipboard(html, content).then(function() {
            App.Alert.show('Copied. Paste into Gmail compose to keep buttons.', 'notice');
            var gmailLink = 'https://mail.google.com/mail/u/0/?view=cm&fs=1' +
              '&to=' + encodeURIComponent(recipient) +
              '&su=' + encodeURIComponent(subject);

            var w = window.open(gmailLink, '_blank');
            if (!w) window.location.href = gmailLink;
          }).catch(function() {
            App.Alert.show('Copy failed', 'alert');
          });
        });
      });
    } catch (e) {
      App.Alert.show('Email editor failed to initialize.', 'alert');
      if (window.console && console.error) console.error(e);
    }
  }

  function esc(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  return { init: init };
})();

$(function() {
  if (App.ArtAssetBatches && typeof App.ArtAssetBatches.init === 'function') {
    App.ArtAssetBatches.init();
  }
});

